import React, { useEffect, useState } from "react";
import sideImage from "./Assets/OwnersPic.png";

const OwnersDataReview = ({setOpenSignupScreen, InstituteData, handleSubmit}) => {

return(
    <div className="w-full flex gap-[20px] h-screen">
        <div className="w-[40%] h-screen  hidden lg:flex">
                <img src={sideImage} alt="sideImage" className="w-full h-[135%] object-cover" />
        </div>

        <div className="w-full lg:w-[60%] p-[30px] flex flex-col gap-[10px]">
            <p className="text-[22px] text-[#5F56A8] font-bold">Registration Data Review</p>
            <p className="text-[22px] text-[#1D1D1D] font-bold underline">Owner Data</p>
            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">First Name</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.ownersData?.FirstName}</p>
            </div>
            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">Last Name</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.ownersData?.LastName}</p>
            </div>
            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">Email</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.ownersData?.email}</p>
            </div>

            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">Postal Code</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.ownersData?.postalCode}</p>
            </div>

            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">Country</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.ownersData?.country}</p>
            </div>

            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">Province</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.ownersData?.province}</p>
            </div>

            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">City</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.ownersData?.city}</p>
            </div>

            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">Address</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.ownersData?.Address}</p>
            </div>

            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">Owner Contact Number</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.ownersData?.contactNumber}</p>
            </div>

            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">Emergency Contact Number</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.ownersData?.emergencyNumber}</p>
            </div>

            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">Emergency Email Address</p>
                    <p className="text-[18px] text-[#000000]">{InstituteData?.ownersData?.emergencyEmail}</p>
            </div>

            <div className="w-full flex justify-between">
                    <p className="text-[18px] text-[#000000] font-bold">Owner Photo ID</p>
                    <p className="text-[18px] text-[#000000] font-bold">Owner Picture</p>
            </div>

            <div className="w-full flex justify-between">
                <div className="w-[100px] h-[100px] bg-[#F3F6F7] rounded-[9px]">
                        {InstituteData.ownersData.ownerIdFront ? (
                        <img src={InstituteData.ownersData.ownerIdFront.previewURL} alt="ownerIdFront Preview" className="w-full h-full object-cover rounded-[9px]" />
                        ) : null}
                </div>
                <div className="w-[100px] h-[100px] bg-[#F3F6F7] rounded-[9px]">
                        {InstituteData.ownersData.ownerPicture ? (
                        <img src={InstituteData.ownersData.ownerPicture.previewURL} alt="ownerPicture Preview" className="w-full h-full object-cover rounded-[9px]" />
                        ) : null}
                </div>
            </div>

            <div className="w-full flex justify-between">
                <div className="flex flex-col gap-[5px]">
                    <p className="text-[18px] text-[#000000] font-bold">Owner Signature </p>
                    <p className="text-[12px] text-[#000000]">(To be used on certificate)</p>
                </div>
                <div className="w-[100px] h-[100px] bg-[#F3F6F7] rounded-[9px]">
                        {InstituteData.ownersData.ownerSignatureImage ? (
                        <img src={InstituteData.ownersData.ownerSignatureImage.previewURL} alt="ownerSignatureImage Preview" className="w-full h-full object-cover rounded-[9px]" />
                        ) : null}
                </div>
            </div>

            <div className="w-full flex flex-col justify-center items-center gap-[15px] mt-[20px] pb-[50px] lg:pb-[0px]">
                <button
                    className={`w-[80%] cursor-pointer rounded-[8px] border-none bg-primary  py-2
                            text-[16px] text-white  xl:py-2 
                                xl:text-[18px]     2xl:text-base`}
                    onClick={handleSubmit}
                >
                    Submit
                </button>
                <p className="text-[18px] text-[#625BA8] cursor-pointer" onClick={()=>setOpenSignupScreen("OwnerRegisteration")}>Edit</p>
            </div>
        </div>
    </div>
)
}

export default OwnersDataReview;